import axios from '../helpers/axios'
import { logError } from '../services';
import qs from 'querystring';
import { IDropdownResponse, IETLJob, IResponse, IETLJobHistory } from '../models';

export const getEtlJobs = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get('/api/etl-jobs');
    return data;
  } catch (error) {
    logError(error, 'getEtlJobs failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getEtlJob = async (filters?: { page?: number; perPage: number; sortBy?: string; sortDirection?: string }): Promise<IETLJob> => {
  try {
    const { data } = await axios.get('/api/etl-jobs/1', {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getEtlJob failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getEtlJobHistory = async (filters?: {
  page?: number;
  perPage: number;
  sortBy?: string;
  sortDirection?: string;
  endDate?: string;
  startDate?: string;
  searchText?: string;
}): Promise<IResponse<IETLJobHistory[]>> => {
  try {
    const { data } = await axios.get('/api/etl-jobs/1/history', {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getEtlJobHistory failed');
    return Promise.reject(error?.response?.data);
  }
};
